import deleteInvestigationApi from "@custom/rtk-apis/billing/deleteInvestigation";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""
};

const deleteInvestigationSlice = createSlice({
  name: "deleteInvestigationSlice",
  initialState,
  reducers: {
    closePatientDeleteModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deleteInvestigationApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deleteInvestigationApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteInvestigationApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteInvestigationSlice.reducer;
export const { closePatientDeleteModal } = deleteInvestigationSlice.actions;
